/* gs-variant-pills v3 */
(function(){
  var CSS = [
    '.gs-variant-pills{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 16px;}',
    '.gs-variant-pills button{background:#1a1a1a;border:1.5px solid rgba(255,255,255,0.15);color:#f0f0f0;',
    'padding:10px 14px;border-radius:6px;cursor:pointer;font-size:0.8rem;text-align:left;',
    'transition:border-color 0.2s,color 0.2s,background 0.2s;line-height:1.4;}',
    '.gs-variant-pills button:hover{border-color:rgba(201,169,97,0.5);color:#c9a961;}',
    '.gs-variant-pills button.active{border-color:#c9a961;color:#c9a961;background:rgba(201,169,97,0.08);}',
    '.gs-pill-name{display:block;font-weight:600;margin-bottom:2px;}',
    '.gs-pill-price{display:block;font-size:0.82rem;opacity:0.75;}',
    '.gs-pd__price{font-family:"Cormorant Garamond",serif;font-size:2rem;font-weight:700;',
    'color:#c9a961;margin:8px 0 16px;display:block!important;}'
  ].join('');
  var s = document.createElement('style');
  s.textContent = CSS;
  document.head.appendChild(s);

  function buildPills(){
    var sel = document.querySelector('select[name="id"]');
    if(!sel||sel.dataset.pillsDone) return;
    sel.dataset.pillsDone='1';

    // Build price lookup from option text
    var prices={};
    Array.from(sel.options).forEach(function(o){
      var m=o.text.match(/\$([\.\d,]+)/);
      if(m) prices[o.value]='$'+m[1];
    });

    // Show + set initial price on the base price div
    var pd=document.getElementById('gsPdBasePrice');
    if(pd){
      var init=sel.options[sel.selectedIndex];
      if(init&&prices[init.value]) pd.textContent=prices[init.value];
      pd.style.cssText='display:block!important;';
    }

    // Build pill container
    var wrap=document.createElement('div');
    wrap.className='gs-variant-pills';

    Array.from(sel.options).forEach(function(o,i){
      var btn=document.createElement('button');
      btn.type='button';
      btn.dataset.value=o.value;

      var parts=o.text.split(/\s*\u2014\s*|\s*—\s*/);
      var name=parts[0]||o.text;
      var price=parts[1]||(prices[o.value]||'');

      btn.innerHTML='<span class="gs-pill-name">'+name+'</span>'+(price?'<span class="gs-pill-price">'+price+'</span>':'');
      if(i===sel.selectedIndex) btn.classList.add('active');

      btn.addEventListener('click',function(){
        var id=btn.dataset.value;
        sel.value=id;

        var hidden=document.querySelector('form input[name="id"][type="hidden"]')||
          document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if(hidden) hidden.value=id;

        ['change','input'].forEach(function(ev){
          sel.dispatchEvent(new Event(ev,{bubbles:true}));
          if(hidden) hidden.dispatchEvent(new Event(ev,{bubbles:true}));
        });

        wrap.querySelectorAll('button').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');

        // Update price display
        if(pd&&prices[id]){
          pd.textContent=prices[id];
          pd.style.cssText='display:block!important;';
        }
      });
      wrap.appendChild(btn);
    });

    sel.style.display='none';
    sel.parentNode.insertBefore(wrap,sel);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',buildPills);
  else buildPills();
})();